import { RefObject } from 'preact';

import { UnsafeDomHandle, UNSAFE_DOM_ACCESS } from '#utils/UNSAFE_unsafeDomAccess';

/**
 * Extracts and returns an element from an element-based ref
 *
 * @returns the element or null if no element can be extracted
 */
export function toUnsafeDomElement(
  elementRef?: RefObject<Element> | RefObject<UnsafeDomHandle<Element>> | null
) {
  const current = elementRef?.current;

  if (current) {
    return current instanceof Element ? current : current[UNSAFE_DOM_ACCESS];
  }

  return null;
}
